import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import Logo from "../common/Logo";
import { DehazeOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  getUserProfile,
  setLogoutAction,
} from "../../store/reducers/userSlice";
import { useSelector } from "react-redux";
import UserIcon from "../../assets/images/black_user.png";
import AssignNotificationIcon from "../../assets/svg/assign_notification.svg";
import {
  clearLeadDetails,
  setAllLeadListAction,
  setSingleLeadAction,
} from "../../store/reducers/leadSlice";
import CustomButton from "../common/button/CustomButton";
import { setAllTCDocumentListAction } from "../../store/reducers/documentSlice";
import { setAllFeedbackListAction } from "../../store/reducers/feedbackSlice";
import {
  getAssignNotificationMessageAction,
  getLeadNotificationMessageAction,
  getNotificationMessageAction,
} from "../../store/reducers/mmymSlice";
import { setFeedbackQuestionAction } from "../../store/reducers/customerFeedbackSlice";
import { setQuotationAction } from "../../store/reducers/customerSlice";
import { getConfirmationNotificationAction } from "../../store/reducers/clientConfirmationSlice";
import { Collapse, Pagination } from "@mui/material";
import {
  getStorageNotificationAction,
  markStorageNotificationReadAction,
} from "../../store/reducers/contractStorageSlice";
import {
  getSmsNotificationListAction,
  makrSmsReadResponse,
  markSmsReadAction,
} from "../../store/reducers/templateSlice";

interface HeaderProps {
  toggleSidebar: () => void;
}

type SectionKey = "confirmation" | "lead" | "sms" | "storage";

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const location = useLocation(); // Get the current location
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const [notificationAnchorE1, setNotificationAnchorE1] =
    React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [isShowRedDot, setIsShowRedDot] = React.useState<any>(null);
  const [smsPage, setSmsPage] = React.useState(1);
  const [storagePage, setStoragePage] = React.useState(1);
  const { user, userProfile, isUserUpdateSuccess, permissions } = useSelector(
    (state: any) => state?.user,
  );

  console.log("userProfile", userProfile);
  console.log("permissions", permissions);
  // ✅ COMMON ROLE CHECK
  const isOwnerOrTenantOrAdmin =
    user?.user?.roles?.includes("Owner") ||
    user?.user?.roles?.includes("TENANT") ||
    user?.user?.roles?.includes("Admin");
  const canSeeLead = Boolean(
    isOwnerOrTenantOrAdmin || permissions?.["Lead"]?.read,
  );
  const canSeeSms = Boolean(
    isOwnerOrTenantOrAdmin || permissions?.["Notification"]?.read,
  );
  const canSeeStorage = Boolean(
    isOwnerOrTenantOrAdmin || permissions?.["Storage"]?.read,
  );

  const { leadNotificationMessageList } = useSelector(
    (state: any) => state?.mmym,
  );

  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorE1(event.currentTarget);

    if (canSeeSms) {
      dispatch(getNotificationMessageAction());
      dispatch(getSmsNotificationListAction({ page: 1, limit: 10 }));
    }

    if (canSeeLead) {
      dispatch(getConfirmationNotificationAction());
      dispatch(getLeadNotificationMessageAction());
    }

    if (canSeeStorage) {
      setStoragePage(1);
      dispatch(getStorageNotificationAction({ page: 1, limit: 10 }));
    }

    // Only mark notification as seen if user has permission
    if (canSeeSms || canSeeLead || canSeeStorage) {
      localStorage.setItem("isSeenNotification", "true");
      setIsShowRedDot("true");
    }
  };

  const handleAssignNotificationClick = (
    event: React.MouseEvent<HTMLElement>,
  ) => {
    dispatch(
      getAssignNotificationMessageAction({ userId: user?.user?.staff_id }),
    );
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const {
    smsNotificationLists,
    smsNotificationListPagination,
    isMarkSmsResponse,
  } = useSelector((state: any) => state.template);
  const { confirmationNotification } = useSelector(
    (state: any) => state?.confirmation,
  );
  const { storageNotification } = useSelector(
    (state: any) => state?.contractStorage,
  );
  console.log("smsNotificationLists", smsNotificationLists);
  React.useEffect(() => {
    const storedNotificationData = localStorage.getItem("isSeenNotification");
    if (storedNotificationData) {
      setIsShowRedDot(storedNotificationData);
    }
  }, []);

  const [formData, setFormData] = React.useState({
    userId: "",
    // sub:"",
    isLogoutAllDevices: false,
  });

  // ✅ NEW: accordion state (purane tabValue ki jagah)
  const [expandedSection, setExpandedSection] =
    React.useState<SectionKey | null>(null);

  // ✅ NEW: accordion toggle (fetch logic purane handleTabChange jaisa hi hai)
  const handleSectionToggle = (key: SectionKey) => {
    // already open hai to band kar do
    if (expandedSection === key) {
      setExpandedSection(null);
      return;
    }
    setExpandedSection(key);

    if (key === "confirmation") {
      // Confirmations
      if (canSeeLead) {
        dispatch(getConfirmationNotificationAction());
      }
    }

    if (key === "lead") {
      // Lead Notifications
      if (canSeeLead) {
        dispatch(getLeadNotificationMessageAction());
      }
    }

    if (key === "sms") {
      // SMS
      if (canSeeSms) {
        setSmsPage(1);

        dispatch(
          getSmsNotificationListAction({
            page: 1,
            limit: 10,
          }),
        );
      }
    }

    if (key === "storage" && canSeeStorage) {
      setStoragePage(1);
      dispatch(getStorageNotificationAction({ page: 1, limit: 10 }));
    }
  };

  React.useEffect(() => {
    if (userProfile && user) {
      setFormData({
        ...formData,
        // userId: userProfile?.id || userProfile?.staff_id,
        userId: user?.user?.sub,
      });
    }
  }, [userProfile, user]);

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleSignout = () => {
    dispatch(setLogoutAction(formData));
    setTimeout(() => {
      navigate("/");
      dispatch(clearLeadDetails());
      dispatch(
        setAllLeadListAction({ pagination: { currentPage: 1 }, list: [] }),
      );
      dispatch(setSingleLeadAction(null));
      dispatch(setAllTCDocumentListAction(null));
      dispatch(setAllFeedbackListAction([]));
      if (user?.user?.roles?.includes("CUSTOMER")) {
        dispatch(setFeedbackQuestionAction(null));
        dispatch(setQuotationAction(null));
      }
    }, 1500);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const navigateProfile = () => {
    navigate(`/profile`);
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  React.useEffect(() => {
    dispatch(getUserProfile());
  }, [dispatch]);

  const { notificationMessageList } = useSelector((state: any) => state?.mmym);

  const navigateSurveyDiary = () => {
    if (location.pathname === "/survey-diary") {
      navigate(`/dashboard`);
    } else {
      navigate(`/survey-diary`);
    }
  };
  React.useEffect(() => {
    if (isUserUpdateSuccess) {
      dispatch(getUserProfile());
    }
  }, [isUserUpdateSuccess]);

  // reset to page 1 each time the notification menu is freshly opened
  React.useEffect(() => {
    if (notificationAnchorE1) {
      setSmsPage(1);
    }
  }, [notificationAnchorE1]);

  const formatSmsDate = (dateString: string) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
      d.getHours(),
    )}:${pad(d.getMinutes())}`;
  };

  // ✅ NEW: relative time (e.g. "5 min", "2 hr", "Yesterday")
  const timeAgo = (dateString?: string) => {
    if (!dateString) return "";
    const diff = Date.now() - new Date(dateString).getTime();
    const min = Math.floor(diff / 60000);
    if (min < 1) return "now";
    if (min < 60) return `${min} min`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} hr`;
    const day = Math.floor(hr / 24);
    return day === 1 ? "Yesterday" : `${day} days`;
  };

  const handleMarkSmsRead = async (notification: any) => {
    if (notification?.unread === false) return; // already read, nothing to do
    try {
      await (
        dispatch(markSmsReadAction({ ids: [notification.id] })) as any
      ).unwrap();
    } catch (err) {
      console.error("Failed to mark SMS as read", err);
    } finally {
      dispatch(getSmsNotificationListAction({ page: smsPage, limit: 10 }));
    }
  };

  const handleMarkAllSmsRead = async () => {
    const unreadIds =
      smsNotificationLists
        ?.filter((n: any) => n?.unread)
        ?.map((n: any) => n.id) || [];

    if (unreadIds.length === 0) return;

    try {
      await (dispatch(markSmsReadAction({ ids: unreadIds })) as any).unwrap();
    } catch (err) {
      console.error("Failed to mark all SMS as read", err);
    } finally {
      dispatch(getSmsNotificationListAction({ page: smsPage, limit: 10 }));
    }
  };

  React.useEffect(() => {
    if (isMarkSmsResponse && smsPage) {
      dispatch(getSmsNotificationListAction({ page: smsPage, limit: 10 }));
      dispatch(makrSmsReadResponse(false));
    }
  }, [isMarkSmsResponse]);

  // ✅ NEW: derived values for notification panel
  const leadList = leadNotificationMessageList?.notifications || [];
  const confirmationCount = confirmationNotification?.length || 0;
  const leadCount = leadList.length;
  const unreadSmsCount =
    smsNotificationLists?.filter((n: any) => n?.unread === true)?.length || 0;
  const storageNotificationList = storageNotification?.list || [];
  const storageNotificationPagination = storageNotification?.pagination;
  const unreadInventoryCount =
    storageNotificationList?.filter((n: any) => n?.unread === true)?.length || 0;
  const getTotalPages = (pagination: any) => {
    const totalPages = Number(pagination?.totalPages);
    if (Number.isFinite(totalPages) && totalPages > 0) return totalPages;

    const totalItems = Number(pagination?.totalItems);
    const itemsPerPage = Number(pagination?.itemsPerPage) || 10;
    const calculatedPages = Math.ceil(totalItems / itemsPerPage);
    return Number.isFinite(calculatedPages) && calculatedPages > 0
      ? calculatedPages
      : 1;
  };
  const smsTotalPages = getTotalPages(smsNotificationListPagination);
  const storageTotalPages = getTotalPages(storageNotificationPagination);

  // ✅ NEW: menu khulte hi pehla available section khul jaye
  React.useEffect(() => {
    if (notificationAnchorE1) {
      if (canSeeLead) setExpandedSection("confirmation");
      else if (canSeeSms) setExpandedSection("sms");
      else if (canSeeStorage) setExpandedSection("storage");
    }
  }, [notificationAnchorE1]);

  // ✅ NEW: section header (dot + title + badge + time + arrow)
  const renderSectionHeader = (
    key: SectionKey,
    label: string,
    color: string,
    count: number,
    time?: string,
  ) => (
    <Box
      onClick={() => handleSectionToggle(key)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "14px 16px",
        cursor: "pointer",
        borderTop: "1px solid #ECECEC",
        "&:hover": { backgroundColor: "#F7F7F7" },
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{ fontWeight: 700, fontSize: 14, color: "#222", flex: 1 }}
      >
        {label}
      </Typography>

      {count > 0 && (
        <Box
          sx={{
            minWidth: 20,
            height: 20,
            borderRadius: "10px",
            padding: "0 6px",
            backgroundColor: "#0B7A5E",
            color: "#fff",
            fontSize: 12,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {count}
        </Box>
      )}
      {/* {time && (
        <Typography sx={{ fontSize: 12, color: "#8a8a8a" }}>{time}</Typography>
      )} */}
      <ExpandMoreIcon
        sx={{
          fontSize: 20,
          color: "#8a8a8a",
          transition: "transform .2s",
          transform:
            expandedSection === key ? "rotate(180deg)" : "rotate(0deg)",
        }}
      />
    </Box>
  );

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      sx={{ mt: "45px" }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        onClick={
          user?.user?.roles?.includes("CUSTOMER") ||
          user?.user?.roles?.includes("Customer")
            ? () => {}
            : navigateProfile
        }
      >
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography sx={{ fontWeight: "bold" }}>
            {userProfile?.name}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "normal" }}>
            {userProfile?.email}
          </Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={handleSignout}>Sign out</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem
        onClick={(e: any) => {
          handleMobileMenuClose();
          handleNotificationClick(e);
        }}
      >
        <IconButton size="large" color="inherit">
          <Badge
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            variant="dot"
            badgeContent={isShowRedDot === "true" ? 0 : " "}
            color="error"
          >
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1, background: "#008E72", color: "#fff" }}>
      <AppBar
        position="static"
        color="transparent"
        sx={{
          boxShadow: "0px 7px 13px 4px rgba(0,0,0,0.10)",
          paddingBottom: "10px",
        }}
      >
        <Toolbar>
          <Logo isPosition={false} isTitle={false} />
          {user?.user?.roles?.includes("TENANT") ||
          user?.user?.roles?.includes("Admin") ||
          !(
            user?.user?.roles?.length === 1 &&
            (user?.user?.roles[0] === "Surveyor" ||
              user?.user?.roles?.includes("CUSTOMER"))
          ) ? (
            <IconButton
              onClick={toggleSidebar}
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ ml: 0, position: "relative" }}
            >
              <DehazeOutlined />
            </IconButton>
          ) : (
            <>
              {!user?.user?.roles?.includes("Surveyor") ||
              !user?.user?.roles?.includes("Surveyor") ? (
                ""
              ) : (
                <CustomButton
                  style={{
                    marginLeft: "20px",
                    background: "#fff",
                    fontWeight: "600",
                    color: "#008e72",
                    cursor: "pointer",
                  }}
                  variant="outlined"
                  title={
                    location.pathname === "/survey-diary"
                      ? "Dashboard"
                      : "Survey Diary"
                  }
                  onClick={navigateSurveyDiary}
                />
              )}
            </>
          )}

          <Box sx={{ flexGrow: 1 }} />
          {/* {user?.user?.roles?.includes("CUSTOMER") ||
          user?.user?.roles?.includes("Customer") ? (
            ""
          ) : (
            <CustomSearchBar />
          )} */}

          <Box sx={{ flexGrow: 1 }} />
          <Typography
            sx={{
              marginRight: "8px",
              fontWeight: 600,
              display: { xs: "none", md: "flex" },
            }}
          >
            {userProfile?.companyName ?? ""}
          </Typography>
          {(isOwnerOrTenantOrAdmin ||
            permissions?.["Notification"]?.read ||
            permissions?.["Lead"]?.read ||
            permissions?.["Storage"]?.read) && (
            <>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <IconButton
                  size="large"
                  aria-label="show new notifications"
                  color="inherit"
                  onClick={handleNotificationClick}
                >
                  <Badge
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    variant="dot"
                    badgeContent={isShowRedDot === "true" ? 0 : " "}
                    color="error"
                  >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>

                {/* ✅ NEW NOTIFICATION PANEL (accordion style) */}
                <Menu
                  anchorEl={notificationAnchorE1}
                  open={Boolean(notificationAnchorE1)}
                  onClose={() => setNotificationAnchorE1(null)}
                  MenuListProps={{ disablePadding: true }}
                  sx={{
                    marginTop: "60px",
                    "& .MuiPaper-root": {
                      width: "400px",
                      maxHeight: "80vh",
                      overflowY: "auto",
                      borderRadius: "12px !important",
                      boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
                    },
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  {/* Title row */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "16px",
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: 700, fontSize: 16, color: "#222" }}
                    >
                      Notifications
                    </Typography>
                  </Box>

                  {/* ---------------- Confirmations ---------------- */}
                  {canSeeLead &&
                    renderSectionHeader(
                      "confirmation",
                      "Confirmations",
                      "#0B7A5E",
                      confirmationCount,
                    )}
                  {canSeeLead && (
                    <Collapse
                      in={expandedSection === "confirmation"}
                      unmountOnExit
                    >
                      <Box>
                        {confirmationCount > 0 ? (
                          confirmationNotification.map(
                            (notification: any, index: any) => (
                              <Box
                                key={index}
                                sx={{
                                  padding: "12px 16px",
                                  backgroundColor: "#F4FAF8",
                                  borderTop: "1px solid #ECECEC",
                                  cursor: "pointer",
                                  "&:hover": { backgroundColor: "#E8F4F0" },
                                }}
                                onClick={() => {
                                  setNotificationAnchorE1(null); // ⬅️ Close the menu
                                  const leadId = notification?.lead_id;
                                  sessionStorage.setItem(
                                    "selectedJobLeadId",
                                    JSON.stringify(Number(leadId)),
                                  );
                                  setTimeout(() => {
                                    navigate("/dashboard");
                                  }, 100);
                                }}
                              >
                                <Typography sx={{ fontSize: 13, color: "#333" }}>
                                  Lead <b>{notification?.name}</b> has been
                                  successfully confirmed by the customer.
                                </Typography>
                              </Box>
                            ),
                          )
                        ) : (
                          <Typography
                            sx={{
                              padding: "14px 16px",
                              fontSize: 13,
                              color: "#8a8a8a",
                            }}
                          >
                            No Confirmation Found
                          </Typography>
                        )}
                      </Box>
                    </Collapse>
                  )}

                  {/* ---------------- Leads ---------------- */}
                  {canSeeLead &&
                    renderSectionHeader("lead", "Leads", "#2F6FDE", leadCount)}
                  {canSeeLead && (
                    <Collapse in={expandedSection === "lead"} unmountOnExit>
                      <Box>
                        {leadCount > 0 ? (
                          leadList.map((notification: any) => (
                            <Box
                              key={notification.id}
                              sx={{
                                padding: "12px 16px",
                                backgroundColor:
                                  notification?.color || "#F7F7F7",
                                borderTop: "1px solid #ECECEC",
                                textAlign: "left",
                              }}
                            >
                              <Typography sx={{ fontSize: 13, color: "#333" }}>
                                {notification.message}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <Typography
                            sx={{
                              padding: "14px 16px",
                              fontSize: 13,
                              color: "#8a8a8a",
                            }}
                          >
                            No Notification Found
                          </Typography>
                        )}
                      </Box>
                    </Collapse>
                  )}

                  {/* ---------------- SMS ---------------- */}
                  {canSeeSms &&
                    renderSectionHeader(
                      "sms",
                      "SMS",
                      "#7B4FD6",
                      unreadSmsCount,
                      timeAgo(smsNotificationLists?.[0]?.created_at),
                    )}
                  {canSeeSms && (
                    <Collapse in={expandedSection === "sms"} unmountOnExit>
                      <Box>
                        {unreadSmsCount > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              padding: "8px 16px",
                              borderTop: "1px solid #ECECEC",
                            }}
                          >
                            <Button
                              size="small"
                              onClick={handleMarkAllSmsRead}
                              sx={{
                                color: "#008E72",
                                fontWeight: 600,
                                textTransform: "none",
                              }}
                            >
                              Mark all SMS as read
                            </Button>
                          </Box>
                        )}
                        {smsNotificationLists?.length > 0 ? (
                          smsNotificationLists.map(
                            (notification: any, index: number) => {
                                const isUnread = notification?.unread === true;
                                return (
                                  <Box
                                    key={notification?.id ?? index}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      gap: "12px",
                                      padding: "12px 16px",
                                      backgroundColor: isUnread
                                        ? "#EEF8FC"
                                        : "#FAFAFA",
                                      borderLeft: isUnread
                                        ? "3px solid #1BA8D5"
                                        : "3px solid transparent",
                                      borderTop: "1px solid #ECECEC",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setNotificationAnchorE1(null);
                                      sessionStorage.setItem(
                                        "selectedJobLeadId",
                                        JSON.stringify(
                                          Number(notification?.lead_id),
                                        ),
                                      );
                                      setTimeout(
                                        () => navigate("/dashboard"),
                                        100,
                                      );
                                    }}
                                  >
                                    <Box>
                                      <Typography
                                        sx={{
                                          fontWeight: isUnread ? 700 : 500,
                                          fontSize: 13,
                                          color: "#222",
                                        }}
                                      >
                                        {notification?.actor_name}{" "}
                                        {notification?.lead_id} responded
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: "#8a8a8a" }}
                                      >
                                        {formatSmsDate(
                                          notification?.created_at,
                                        )}
                                      </Typography>
                                    </Box>

                                    <Box
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMarkSmsRead(notification);
                                      }}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        backgroundColor: "#fff",
                                        borderRadius: "20px",
                                        padding: "4px 12px",
                                        cursor: "pointer",
                                        boxShadow:
                                          "0px 1px 3px rgba(0,0,0,0.15)",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {isUnread ? (
                                        <RadioButtonUncheckedIcon
                                          sx={{
                                            color: "#008E72",
                                            fontSize: 18,
                                          }}
                                        />
                                      ) : (
                                        <CheckCircleIcon
                                          sx={{
                                            color: "#008E72",
                                            fontSize: 18,
                                          }}
                                        />
                                      )}
                                      <Typography
                                        variant="body2"
                                        sx={{ fontSize: 12 }}
                                      >
                                        {isUnread ? "Mark read" : "Read"}
                                      </Typography>
                                    </Box>
                                  </Box>
                                );
                            },
                          )
                        ) : (
                          <Typography
                            sx={{
                              padding: "14px 16px",
                              fontSize: 13,
                              color: "#8a8a8a",
                            }}
                          >
                            No SMS Found
                          </Typography>
                        )}
                        {smsTotalPages >= 1 && (
                          <Box
                            sx={{
                              position: "sticky",
                              bottom: 0,
                              zIndex: 1,
                              display: "flex",
                              justifyContent: "center",
                              padding: "12px 0",
                              borderTop: "1px solid #ECECEC",
                              backgroundColor: "#fff",
                            }}
                          >
                            <Pagination
                              count={smsTotalPages}
                              page={
                                Number(smsNotificationListPagination?.currentPage) ||
                                smsPage
                              }
                              onChange={(_event, value) => {
                                setSmsPage(value);
                                dispatch(
                                  getSmsNotificationListAction({
                                    page: value,
                                    limit: 10,
                                  }),
                                );
                              }}
                              color="primary"
                              size="small"
                              shape="rounded"
                            />
                          </Box>
                        )}
                      </Box>
                    </Collapse>
                  )}

                  {/* ---------------- Storage ---------------- */}
                  {canSeeStorage &&
                    renderSectionHeader(
                      "storage",
                      "Inventory",
                      "#D18B27",
                      storageNotificationPagination?.totalItems ??
                        storageNotificationList.length,
                    )}
                  {canSeeStorage && (
                    <Collapse in={expandedSection === "storage"} unmountOnExit>
                      <Box>
                        {unreadInventoryCount > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              padding: "8px 16px",
                              borderTop: "1px solid #ECECEC",
                            }}
                          >
                            <Button
                              size="small"
                             onClick={() =>
                                    dispatch(
                                      markStorageNotificationReadAction({
                                        inventoryIds: [],
                                        all:true
                                      }),
                                    )
                                  }
                              sx={{
                                color: "#008E72",
                                fontWeight: 600,
                                textTransform: "none",
                              }}
                            >
                              Mark all as read
                            </Button>
                          </Box>
                        )}

                        {storageNotificationList.length > 0 ? (
                          storageNotificationList.map(
                            (notification: any, index: number) => (
                              <Box
                                key={notification?.id ?? index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "12px",
                                  padding: "12px 16px",
                                  backgroundColor: !notification?.unread
                                    ? "#FAFAFA"
                                    : "#EEF8FC",
                                  borderLeft: !notification?.unread
                                    ? "3px solid transparent"
                                    : "3px solid #1BA8D5",
                                  borderTop: "1px solid #ECECEC",
                                  textAlign: "left",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 13,
                                    color: "#333",
                                    fontWeight: !notification?.unread ? 500 : 700,
                                  }}
                                >
                                  {notification?.customer_name}{" "}
                                  {notification?.lead_id} inventory submitted
                                </Typography>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  disabled={!notification?.unread}
                                  onClick={() =>
                                    dispatch(
                                      markStorageNotificationReadAction({
                                        inventoryIds: [notification?.inventory_id],
                                        all:false
                                      }),
                                    )
                                  }
                                  sx={{
                                    flexShrink: 0,
                                    borderRadius: "20px",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {!notification?.unread
                                    ? "Read"
                                    : "Mark as read"}
                                </Button>
                              </Box>
                            ),
                          )
                        ) : (
                          <Typography
                            sx={{
                              padding: "14px 16px",
                              fontSize: 13,
                              color: "#8a8a8a",
                            }}
                          >
                            No Inventory Notification Found
                          </Typography>
                        )}
                        {storageTotalPages >= 1 && (
                          <Box
                            sx={{
                              position: "sticky",
                              bottom: 0,
                              zIndex: 1,
                              display: "flex",
                              justifyContent: "center",
                              padding: "12px 0",
                              borderTop: "1px solid #ECECEC",
                              backgroundColor: "#fff",
                            }}
                          >
                            <Pagination
                              count={storageTotalPages}
                              page={
                                storageNotificationPagination?.currentPage ??
                                storagePage
                              }
                              onChange={(_event, value) => {
                                setStoragePage(value);
                                dispatch(
                                  getStorageNotificationAction({
                                    page: value,
                                    limit: 10,
                                  }),
                                );
                              }}
                              color="primary"
                              size="small"
                              shape="rounded"
                            />
                          </Box>
                        )}
                      </Box>
                    </Collapse>
                  )}
                </Menu>
              </Box>

              {/* assign notification icon AssignNotificationIcon */}
              {/* <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <IconButton
                  size="large"
                  aria-label="show new notifications"
                  color="inherit"
                  onClick={handleAssignNotificationClick}
                >
                  <img
                    src={AssignNotificationIcon}
                    alt="profile"
                    style={{ height: "30px", width: "30px" }}
                  />
                </IconButton>

                <Menu
                  anchorEl={notificationAnchorE1}
                  open={Boolean(notificationAnchorE1)}
                  onClose={() => setNotificationAnchorE1(null)}
                  sx={{
                    marginTop: "60px",
                    padding: "20px",
                    "& .MuiPaper-root": {
                      width: "500px",
                      height:
                        notificationMessageList?.length > 10 ? "528px" : "auto",
                      overflowY: "auto",
                      borderRadius: "10px !important",
                    },
                    "& .MuiList-root": {
                      paddingBottom: 0,
                    },
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Box sx={{ padding: "10px 16px" }}>
                    {notificationMessageList?.length > 0 ? (
                      notificationMessageList.map((notification: any) => (
                        <MenuItem
                          sx={{
                            marginTop: "10px",
                            padding: "16px",
                            whiteSpace: "wrap",
                            borderRadius: 0,
                            backgroundColor: "#EAE9EA",
                            margin: 0,
                            textAlign: "left !important",
                            borderTop: "2px solid #C8C9C9",
                          }}
                          key={notification.id}
                        >
                          <Typography>{notification.message}</Typography>
                        </MenuItem>
                      ))
                    ) : (
                      <Typography sx={{ padding: "16px" }}>
                        No Notification Found
                      </Typography>
                    )}
                  </Box>
                </Menu>
              </Box> */}
            </>
          )}

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              // color="inherit"
            >
              <img
                src={userProfile?.logo ? userProfile?.logo : UserIcon}
                alt="profile"
                style={{ height: "36px", width: "36px" }}
              />
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
};
export default Header;